import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "./auth/authReducer";
import { heReducer } from "./category/heReducer";
import { layoutReducer } from "./common/layoutReducer";
import { monHocReducer } from "./category/monHocReducer";
import { thanhPhanMonReducer } from "./category/thanhPhanMonReducer";
import { congThucTinhDiemReducer } from "./category/congThucTinhDiemReducer";
import { congThucTinhDiemSubReducer } from "./category/congThucTinhDiemSubReducer";
import { thanhPhanThiReducer } from "./category/thanhPhanThiReducer";
import { quyCheReducer } from "./category/quyCheReducer";
import { diemQuyDoiReducer } from "./category/diemQuyDoiReducer";
import { xepLoaiHocTapReducer } from "./category/xepLoaiHocTapReducer";
import { xepHangTotNghiepReducer } from "./category/xepHangTotNghiepReducer";
import { XepLoaiChungChiReducer } from "./category/xepLoaiChungChiReducer";
import { LoaiChungChiReducer } from "./category/loaiChungChiReducer";
import { TieuDeBaoCaoReducer } from "./category/tieuDeBaoCaoReducer";
import { lopReducer } from "./category/lopReducer";
import { toolbarLopReducer } from "./common/toolbarLopReducer";
import { InBangDiemReducer } from "./in-bang-diem/inBangDiemReducer";
import { TongHopKyReducer } from "./tong-hop-diem/tongHopKyReducer";
import trangThaiHocReducer from "./category/trangThaiHocReducer";
import { TongHopNamReducer } from "./tong-hop-diem/tongHopNamReducer";
import { tongHopToanKhoaReducer } from "./tong-hop-diem/tongHopToanKhoaReducer";
import { tienDoNhapDiemLopHanhChinhReducer } from "./tong-hop/tienDoNhapDiemLopHanhChinhReducer";
import { tienDoNhapDiemLopTinChiReducer } from "./tong-hop/tienDoNhapDiemLopTinChiReducer";
import { hocKyDangKyReducer } from "./category/hocKyDangKyReducer";
import { dotXetHocVuReducer } from "./xet-hoc-vu/dotXetHocVuReducer";
import { dotXetHocVuPhamViReducer } from "./xet-hoc-vu/dotXetHocVuPhamViReducer";
import { xetHocVuReducer } from "./xet-hoc-vu/xetHocVuReducer";
import { xetTotNghiepPhamViSinhVienReducer } from "./xet-tot-nghiep/xetTotNghiepPhamViSinhVienReducer";
import { xetTotNghiepLanXetReducer } from "./xet-tot-nghiep/xetTotNghiepLanXetReducer";
import { danhSachTotNghiepReducer } from "./xet-tot-nghiep/danhSachTotNghiepReducer";
import { danhSachNoTotNghiepReducer } from "./xet-tot-nghiep/danhSachNoTotNghiepReducer";
import { danhSachHoanTotNghiepReducer } from "./xet-tot-nghiep/danhSachHoanTotNghiepReducer";
import { xetTotNghiepReducer } from "./xet-tot-nghiep/xetTotNghiepReducer";
import { thamSoHeThongChucNangReducer } from "./category/thamSoHeThongChucNangReducer";
import { dotXetChungChiThamSoXetReducer } from "./xet-chung-chi/dotXetChungChiThamSoXetReducer";
import { dotXetChungChiReducer } from "./xet-chung-chi/dotXetChungChiReducer";
import { dotXetChungChiPhamViReducer } from "./xet-chung-chi/dotXetChungChiPhamViReducer";
import { chungChiSinhVienReducer } from "./xet-chung-chi/chungChiSinhVienReducer";
import { DoanhNghiepThucTapReducer } from "./category/doanhNghiepThucTapReducer";
import { keHoachThucTapReducer } from "./xet-thuc-tap/keHoachThucTapReducer";
import { keHoachThucTapPhamViReducer } from "./xet-thuc-tap/keHoachThucTapPhamViReducer";
import { xetThucTapReducer } from "./xet-thuc-tap/xetThucTapReducer";
import { danhSachDuDieuKienThucTapReducer } from "./xet-thuc-tap/danhSachDuDieuKienThucTapReducer";
import { danhSachKhongDuDieuKienThucTapReducer } from "./xet-thuc-tap/danhSachKhongDuDieuKienThucTapReducer";
import { keHoachThucTapDoanhNghiepReducer } from "./xet-thuc-tap/keHoachThucTapDoanhNghiepReducer";
import { thamSoHeThongReducer } from "./category/thamSoHeThongReducer";
import { chuongTrinhDaoTaoReducer } from "./chuong-trinh-dao-tao/chuongTrinhDaoTaoReducer";
import { chuongTrinhDaoTaoChiTietReducer } from "./chuong-trinh-dao-tao/chuongTrinhDaoTaoChiTietReducer";
import { chuongTrinhDaoTaoKienThucReducer } from "./chuong-trinh-dao-tao/chuongTrinhDaoTaoKienThucReducer";
import { DiemKyHieuReducer } from "./category/diemKyHieuReducer";
import { baoCaoThongKeReducer } from "./bao-cao-thong-ke/baoCaoThongKeReducer";
import { loaiChungChiChungNhanReducer } from "./category/loaiChungChiChungNhanReducer";
import { loaiBangTotNghiepReducer } from "./category/loaiBangTotNghiepReducer";
import { chungChiChungNhanReducer } from "./chung-chi-chung-nhan/chungChiChungNhanReducer";
import { chungChiChungNhanSinhVienReducer } from "./chung-chi-chung-nhan/chungChiChungNhanSinhVienReducer";
import { bieuMauNguoiDungReducer } from "./quan-ly-bieu-mau/bieuMauNguoiDungReducer";
import { traCuuDiemReducer } from "./tra-cuu-diem/traCuuDiemReducer";
import { dotDangKyNganh2Reducer } from "./quan-ly-nganh-2/dotDangKyNganh2Reducer";
import { danhSachDangKyNganh2Reducer } from "./quan-ly-nganh-2/danhSachDangKyNganh2Reducer";
import { quocTichReducer } from "./category/quocTichReducer";
import { dashboardReducer } from "./dashboard/dashboardReducer";
import { xetKhoaLuanReducer } from "./xet-khoa-luan/xetKhoaLuanReducer";
import { dotThiReducer } from "./to-chuc-thi/dotThiReducer";
import { boMonReducer } from "./category/boMonReducer";
import { khoiNganhReducer } from "./category/khoiNganhReducer";
import { hinhThucThiReducer } from "./category/hinhThucThiReducer";
import { hocLaiThiLaiReducer } from "./hoc-lai-thi-lai/hocLaiThiLaiReducer";
import { tinhTrangNoMonReducer } from "./tinh-trang-no-mon/tinhTrangNoMonReducer";
import { keHoachThucTapPhamViSinhVienReducer } from "./xet-thuc-tap/keHoachThucTapPhamViSinhVienReducer";
import { duDieuKienKetQuaHocTapXetTotNghiepReducer } from "./xet-tot-nghiep/duDieuKienKetQuaHocTapXetTotNghiepReducer";
import { khongDuDieuKienKetQuaHocTapXetTotNghiepReducer } from "./xet-tot-nghiep/khongDuDieuKienKetQuaHocTapXetTotNghiepReducer";
import { thietLapChuanDauRaReducer } from "./xet-chung-chi/thietLapChuanDauRaReducer";
import { chuanDauRaChungChiReducer } from "./chuong-trinh-dao-tao/chuanDauRaChungChiReducer";
import { loaiChungChiDanhSachMonReducer } from "./chuong-trinh-dao-tao/loaiChungChiDanhSachMonReducer";
import { hocPhanMienReducer } from "./hoc-phan-mien/hocPhanMienReducer";
import { dotXetChungChiPhamViSinhVienReducer } from "./xet-chung-chi/dotXetChungChiPhamViSinhVienReducer";
import { danhSachNganh2Reducer } from "./quan-ly-nganh-2/danhSachNganh2Reducer";
import { dotXetHocVuPhamViSinhVienReducer } from "./xet-hoc-vu/dotXetHocVuPhamViSinhVienReducer";
import { quyetDinhHocVuReducer } from "./xet-hoc-vu/quyetDinhHocVuReducer";


const reducers = combineReducers({
    auth: authReducer,
    category: combineReducers({
       monHoc: monHocReducer,
       thanhPhanMon : thanhPhanMonReducer,
       thanhPhanThi: thanhPhanThiReducer,
       congThucTinhDiem: congThucTinhDiemReducer,
       congThucTinhDiemSub: congThucTinhDiemSubReducer, 
       quyChe: quyCheReducer,
       diemQuyDoi: diemQuyDoiReducer,
       xepLoaiHocTap: xepLoaiHocTapReducer,
       xepHangTotNghiep: xepHangTotNghiepReducer,
       xepLoaiChungChi: XepLoaiChungChiReducer,
       loaiChungChi: LoaiChungChiReducer,
       tieuDeBaoCao: TieuDeBaoCaoReducer,
       lop: lopReducer,
       trangThaiHoc: trangThaiHocReducer,
       hocKyDangKy:  hocKyDangKyReducer,
       thamSoHeThongChucNang: thamSoHeThongChucNangReducer,
       thamSoHeThong: thamSoHeThongReducer,
       doanhNghiepThucTap: DoanhNghiepThucTapReducer,
       diemKyHieu: DiemKyHieuReducer,
       loaiChungChiChungNhan: loaiChungChiChungNhanReducer,
       loaiBangTotNghiep: loaiBangTotNghiepReducer,
       quocTich: quocTichReducer,
       boMon: boMonReducer,
       khoiNganh: khoiNganhReducer,
       hinhThucThi: hinhThucThiReducer,
       he: heReducer,
    }),
    inBangDiem: InBangDiemReducer,
    tongHopDiem: combineReducers({
       tongHopKy: TongHopKyReducer,
       tongHopNam: TongHopNamReducer,
       tongHopToanKhoa: tongHopToanKhoaReducer,
    }),
    tongHop: combineReducers({
       tienDoNhapDiemLopHanhChinh: tienDoNhapDiemLopHanhChinhReducer,
       tienDoNhapDiemLopTinChi: tienDoNhapDiemLopTinChiReducer,
       baoCaoThongKe: baoCaoThongKeReducer,
    }),
    xetHocVu: combineReducers({
       dotXetHocVu: dotXetHocVuReducer,
       dotXetHocVuPhamVi: dotXetHocVuPhamViReducer,
       dotXetHocVuPhamViSinhVien: dotXetHocVuPhamViSinhVienReducer,
       xetHocVu: xetHocVuReducer,
       quyetDinhHocVu: quyetDinhHocVuReducer,
   }),
   xetTotNghiep: combineReducers({
         xetTotNghiepPhamViSinhVien: xetTotNghiepPhamViSinhVienReducer,
         xetTotNghiepLanXet: xetTotNghiepLanXetReducer,
         danhSachTotNghiep: danhSachTotNghiepReducer,
         danhSachNoTotNghiep: danhSachNoTotNghiepReducer,
         danhSachHoanTotNghiep: danhSachHoanTotNghiepReducer,
         xetTotNghiep: xetTotNghiepReducer,
         duDieuKienKetQuaHocTapXetTotNghiep: duDieuKienKetQuaHocTapXetTotNghiepReducer,
         khongDuDieuKienKetQuaHocTapXetTotNghiep: khongDuDieuKienKetQuaHocTapXetTotNghiepReducer,
   }),
   xetChungChi: combineReducers({
         dotXetChungChi: dotXetChungChiReducer,
         dotXetChungChiPhamVi: dotXetChungChiPhamViReducer,
         dotXetChungChiThamSoXet: dotXetChungChiThamSoXetReducer,
         chungChiSinhVien: chungChiSinhVienReducer,
         thietLapChuanDauRa: thietLapChuanDauRaReducer,
         dotXetChungChiPhamViSinhVien: dotXetChungChiPhamViSinhVienReducer,
   }),
   xetThucTap: combineReducers({
         keHoachThucTap: keHoachThucTapReducer,
         keHoachThucTapPhamVi: keHoachThucTapPhamViReducer,
         keHoachThucTapPhamViSinhVien: keHoachThucTapPhamViSinhVienReducer,
         xetThucTap: xetThucTapReducer,
         keHoachThucTapDoanhNghiep: keHoachThucTapDoanhNghiepReducer,
         danhSachDuDieuKienThucTap: danhSachDuDieuKienThucTapReducer,
         danhSachKhongDuDieuKienThucTap: danhSachKhongDuDieuKienThucTapReducer,
         dotXetChungChiPhamViSinhVien: dotXetChungChiPhamViSinhVienReducer,
   }),
   chuongTrinhDaoTao: combineReducers({
    chuongTrinhDaoTao: chuongTrinhDaoTaoReducer,
    chiTiet: chuongTrinhDaoTaoChiTietReducer,
    chuongTrinhDaoTaoKienThuc: chuongTrinhDaoTaoKienThucReducer,
    chuanDauRaChungChi: chuanDauRaChungChiReducer,
    loaiChungChiDanhSachMon: loaiChungChiDanhSachMonReducer,
  }),
    chungChiChungNhan: combineReducers({
            chungChiChungNhan: chungChiChungNhanReducer,
            chungChiChungNhanSinhVien: chungChiChungNhanSinhVienReducer,
   }),
    bieuMauNguoiDung : bieuMauNguoiDungReducer,
    traCuuDiem: traCuuDiemReducer,
    quanLyNganh2: combineReducers({
      dotDangKyNganh2: dotDangKyNganh2Reducer,
      danhSachDangKyNganh2: danhSachDangKyNganh2Reducer,
      danhSachNganh2: danhSachNganh2Reducer,
    }),
    common: combineReducers({
       layout: layoutReducer,
       toolbarLop: toolbarLopReducer,
    }),
    dashboard: dashboardReducer,
    xetKhoaLuan: xetKhoaLuanReducer,
    toChucThi: combineReducers({
      dotThi: dotThiReducer,
    }),
    hocLaiThiLai: hocLaiThiLaiReducer,
    tinhTrangNoMon: tinhTrangNoMonReducer,
    hocPhanMien: hocPhanMienReducer,
});
    export default reducers;
    export type RootState = ReturnType<typeof reducers>;